<button mat-raised-button color="primary" class="promo__button">Как пользоваться?</button>
